import * as React from 'react';
import { withRouter , BrowserHistory } from "react-router-dom";
import "./static/NavFooter.scss";
class NavFooter extends React.Component< { history: BrowserHistory } , {}> {
    render() {
        return (
            <div className="nav-footer">
                <a href="" className='profile' onClick={() => this.props.history.push("/profile")}>Profile</a> 
                <a href="" className='logout' onClick={() => this.props.history.push("/logout")}>Logout</a>
            </div>
        );
    }
}
export default withRouter(NavFooter);


// WEBPACK FOOTER //
// ./src/component/NavFooter/NavFooter.tsx